// ** Third Party Component
import { ArrowLeft, ArrowRight } from "iconsax-reactjs"

// ** Helpers
import { cn } from "@pma/utils/helpers"

// ** Custom Hooks
import useTranslator from "@pma/hooks/use-translator"

interface CalendarDateProps {
  startDate: any
  endDate: any
}

const CalendarDate = ({ startDate, endDate }: CalendarDateProps) => {
  const { translate, locale } = useTranslator()

  let isDate = false
  const isHebrew = locale === "he"

  if (startDate !== "" && startDate !== null && startDate !== undefined) isDate = true

  return isDate ? (
    <p
      className={cn(
        "flex items-center font-[inter] text-sm font-normal text-neutral-800",
        isHebrew ? "pr-1" : "pl-1",
      )}
    >
      {startDate}{" "}
      {isHebrew ? (
        <ArrowLeft size={16} className='mx-1' />
      ) : (
        <ArrowRight size={16} className='mx-1' />
      )}{" "}
      {endDate}
    </p>
  ) : (
    <p
      className={cn(
        "flex items-center font-[inter] text-sm font-normal text-neutral-800",
        isHebrew ? "pr-1" : "pl-1",
      )}
    >
      {translate("Select Date range")}
    </p>
  )
}

export default CalendarDate
